import { type ApiPath as SafeURL } from '@/services/apiPath';
import { API_ROUTES } from '@/api/apiRoutes';
import { log } from '@/logger/logger.ts';
import { httpReq } from '@/utils/api.utils';
import { safeAxios } from '@/services/safeAxios';
import type {
  CreateSubflowTemplateRequestDto,
  EditSubflowTemplateRequestDto,
  ListSubflowTemplatesResponseDto,
  SubflowTemplateResponseDto,
  SubflowTemplateType,
} from '@/types/api/subflowTemplate';

const logger = log.getLogger('subflowTemplates');

const BASE_PATH = API_ROUTES.subflowTemplates.root();
const templatePath = (id: string): SafeURL => API_ROUTES.subflowTemplates.byId({ subflowTemplateId: id });

export const listSubflowTemplates = async (type?: SubflowTemplateType): Promise<SubflowTemplateResponseDto[]> => {
  try {
    const response = await safeAxios.get<ListSubflowTemplatesResponseDto>(BASE_PATH, {
      ...(type && { params: { type } }),
    });
    return response.data.workspaceSubflowTemplates;
  } catch (error) {
    logger.error('Error listing subflow templates:', error);
    throw error;
  }
};

export const getSubflowTemplate = async (id: string): Promise<SubflowTemplateResponseDto> =>
  httpReq<void, SubflowTemplateResponseDto>(templatePath(id), undefined, 'get');

export const createSubflowTemplate = async (
  dto: CreateSubflowTemplateRequestDto,
): Promise<SubflowTemplateResponseDto> =>
  httpReq<CreateSubflowTemplateRequestDto, SubflowTemplateResponseDto>(BASE_PATH, dto);

export const editSubflowTemplate = async (
  id: string,
  dto: EditSubflowTemplateRequestDto,
): Promise<SubflowTemplateResponseDto> =>
  httpReq<EditSubflowTemplateRequestDto, SubflowTemplateResponseDto>(templatePath(id), dto, 'patch');

export const deleteSubflowTemplate = async (id: string): Promise<void> =>
  httpReq<void, void>(templatePath(id), undefined, 'delete');
